export class Game {
    board;
    settings;
}